var _style, _g, _g2, _g3, _g4, _g5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSlave(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 183.3 188.9",
    style: {
      enableBackground: "new 0 0 183.3 188.9"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n\t.st1{fill:none;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M87.2,96.3C87.2,96.3,87.2,96.3,87.2,96.3v1.1L46,74.8l0-47l41.2,22.6v45.6C87.1,96,87.1,96.2,87.2,96.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M87.2,96.3c0-0.1,0-0.2,0-0.4V50.6L87.2,96.3z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M133.3,27.9v45.3c0,0.3-0.1,0.5-0.4,0.6L93.2,96.5c-0.3,0.2-0.6,0.1-0.7,0c-0.2-0.1-0.4-0.3-0.4-0.6V50.6 c0-0.2,0.1-0.5,0.3-0.6l39.4-22.5c0,0,0.1-0.1,0.1-0.1l0.3-0.2c0.1-0.1,0.3-0.1,0.3-0.1c0.2,0,0.3,0.1,0.4,0.1 C133.1,27.3,133.3,27.5,133.3,27.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M92.5,50c-0.2,0.1-0.3,0.4-0.3,0.6v-0.4C92.2,50.1,92.3,50.1,92.5,50L92.5,50z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M87.1,50.6v45.3c0,0.1,0,0.3,0,0.4L87.1,50.6z M92.4,50c-0.1,0.1-0.2,0.1-0.3,0.2v0.4 C92.1,50.4,92.3,50.1,92.4,50L92.4,50z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M105.5,8.6L64.5,32l-14.6-8c-0.3-0.2-0.4-0.5-0.4-0.7c0-0.2,0-0.5,0.4-0.7L89.3,0.1C89.4,0,89.5,0,89.7,0 c0.1,0,0.2,0,0.4,0.1L105.5,8.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M129.8,22.3c0,0.2-0.1,0.5-0.4,0.7L90.1,45.5L90,45.6c-0.2,0.1-0.5,0.1-0.7,0L69.8,34.9l41-23.4l18.6,10.2 C129.7,21.8,129.8,22.2,129.8,22.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M90.1,45.5c-0.2,0.1-0.4,0.2-0.5,0.3c0,0,0,0-0.1-0.1L69.7,34.9l0.1-0.1l19.5,10.7c0.2,0.1,0.5,0.1,0.7,0 L90.1,45.5z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    className: "st1",
    points: "64.2,35.2 64.1,35.3 64.1,35.3  "
  }), /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 67.2,
    y1: 33.5,
    x2: 67.1,
    y2: 33.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 64.1,
    y1: 35.3,
    x2: 64,
    y2: 35.2
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M162,155.5v-10.6c0-3.9-3.1-7-6.8-7H92.5v18.8c7.2,1.5,12.5,8,12.5,15.8c0,8.9-7,16.1-15.7,16.1 c-8.7,0-15.7-7.2-15.7-16.1c0-8.2,6-15,13.8-16v-18.6h-64c-3.8,0-6.8,3.1-6.8,7V158h-5v-13.2c0-6.7,5.3-12.1,11.8-12.1h64v-24.2h5 v24.2h62.7c6.5,0,11.8,5.4,11.8,12.1v9.9l16.4,33.8h-38.4L162,155.5z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.1,
    y: 158.1,
    className: "st0",
    width: 29,
    height: 29.7
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSlave);
export default __webpack_public_path__ + "static/media/Slave.47bc084039255e3b41fa4c98f7b92803.svg";
export { ForwardRef as ReactComponent };